'use strict';

var jsxRuntime = require('react/jsx-runtime');
var tailwindMerge = require('tailwind-merge');

const UNCHECKED_LINE_COLOR = 'text-w-gray-200 group-hover:text-w-primary';
const CHECKED_LINE_COLOR = 'text-w-white group-hover:text-w-white';
const ERROR_LINE_COLOR = 'text-w-red-500 group-hover:text-w-red-500';
const DISABLED_LINE_COLOR = 'text-w-gray-200 group-hover:text-w-gray-200';
const DRAW_ANIMATION_STYLE = 'stroke-dasharray-[16] stroke-dashoffset-[16] animate-checkbox-check';
const CheckboxButton = ({ type = 'box', disabled, checked = false, isError, isFocused, className })=>{
    const radiusStyle = type === 'circle' ? 'rounded-full' : 'rounded';
    const containerSize = {
        box: 'size-4 m-px',
        circle: 'size-[18px]'
    };
    const generateStyles = ()=>{
        // 비활성화 상태
        if (disabled) {
            if (checked) {
                if (isError) {
                    return 'bg-w-gray-50 border-w-gray-200 cursor-not-allowed';
                }
                return 'bg-primary-100 border-primary-100 cursor-not-allowed';
            }
            return 'border-w-gray-200 bg-w-gray-50 cursor-not-allowed';
        }
        // 포커스 상태 (에러가 없을 때)
        if (isFocused && !isError) {
            if (checked) {
                return 'bg-primary-500 border-primary-500';
            }
            return 'border-primary-500 bg-w-white';
        }
        // 에러 상태
        if (isError) {
            if (checked) {
                return 'border-w-red-500 bg-w-red-500';
            }
            return 'border-w-red-500 bg-w-white';
        }
        // 정상 상태
        if (checked) {
            return 'bg-primary-500 border-primary-500';
        }
        // 기본 상태
        return 'group-hover:border-primary-500 border-w-gray-200 bg-white';
    };
    if (type === 'sub') {
        return jsxRuntime.jsx(SubCheckbox, {
            role: "checkbox-button",
            className: className,
            checked: checked,
            disabled: disabled,
            isError: isError
        });
    }
    return jsxRuntime.jsxs("div", {
        className: tailwindMerge.twMerge('group relative box-border cursor-pointer border', containerSize[type], radiusStyle, generateStyles(), className),
        role: "checkbox-button",
        children: [
            type === 'box' && jsxRuntime.jsx(DefaultCheckMark, {
                checked: checked,
                isError: isError,
                disabled: disabled
            }),
            type === 'circle' && jsxRuntime.jsx(CircleCheckMark, {
                checked: checked,
                isError: isError,
                disabled: disabled
            })
        ]
    });
};
const DefaultCheckMark = ({ checked, isError, disabled })=>{
    return jsxRuntime.jsx("svg", {
        width: "10",
        height: "8",
        viewBox: "0 0 10 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: tailwindMerge.twMerge('absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2', checked && CHECKED_LINE_COLOR, isError && disabled && DISABLED_LINE_COLOR, !checked && 'text-transparent', disabled && (!isError && checked ? CHECKED_LINE_COLOR : 'text-transparent')),
        style: {
            strokeDasharray: checked ? '16' : '0',
            strokeDashoffset: checked ? '16' : '0'
        },
        children: jsxRuntime.jsx("path", {
            d: "M1 3.8L4 7L9 1",
            stroke: "currentColor",
            strokeWidth: "1.6",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            className: checked ? DRAW_ANIMATION_STYLE : ''
        })
    });
};
const CircleCheckMark = ({ checked, isError, disabled })=>jsxRuntime.jsx("svg", {
        width: "10",
        height: "8",
        viewBox: "0 0 10 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: tailwindMerge.twMerge('absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2', checked && CHECKED_LINE_COLOR, isError && disabled && DISABLED_LINE_COLOR, !checked && UNCHECKED_LINE_COLOR, isError && !checked && ERROR_LINE_COLOR, disabled && (!isError && checked ? CHECKED_LINE_COLOR : DISABLED_LINE_COLOR)),
        style: {
            strokeDasharray: checked ? '16' : '0',
            strokeDashoffset: checked ? '16' : '0'
        },
        children: jsxRuntime.jsx("path", {
            d: "M1 3.8L4 7L9 1",
            stroke: "currentColor",
            strokeWidth: "1.6",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            className: checked ? DRAW_ANIMATION_STYLE : ''
        })
    });
const SubCheckbox = ({ role, className, checked, disabled, isError })=>{
    const CHECK_COLOR = 'text-primary';
    const DISABLED_CHECK_COLOR = 'text-primary-100';
    const ERROR_COLOR = 'text-w-red-500';
    const DISABLED_COLOR = 'text-w-gray-100';
    const UNCHECKED_COLOR = 'text-w-gray-200';
    const generateCheckMarkColor = ()=>{
        if (isError) {
            return disabled ? DISABLED_COLOR : ERROR_COLOR;
        }
        if (disabled) {
            return checked ? DISABLED_CHECK_COLOR : DISABLED_COLOR;
        }
        return checked ? CHECK_COLOR : UNCHECKED_COLOR;
    };
    const checkMarkColor = generateCheckMarkColor();
    return jsxRuntime.jsx("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: role,
        className: tailwindMerge.twMerge('cursor-pointer', disabled && 'cursor-not-allowed', checkMarkColor, className),
        "data-testid": "design-system--sub-checkbox",
        children: jsxRuntime.jsx("path", {
            d: "M4 8.76667L7.75004 12.5L14.0001 5.5",
            stroke: "currentColor",
            strokeWidth: "1.4",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};

exports.CheckboxButton = CheckboxButton;
